import { render } from "./SkychartTelescopeLegend.vue?vue&type=template&id=85b7cb9a"
import script from "./SkychartTelescopeLegend.vue?vue&type=script&lang=js"
export * from "./SkychartTelescopeLegend.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__